export const eventTypes = [
  { id: 0, text: 'Comments', value: 'Contact Comments' },
  { id: 1, text: 'Email Sent', value: 'Email Sent', dashboard: true },
  { id: 3, text: 'Text Sent', value: 'Text Sent', dashboard: true },
  { id: 5, text: 'Outbound Call', value: 'Outbound Click to Call', dashboard: true },
  { id: 6, text: 'Inbound Call', value: 'Inbound Call', dashboard: true },
  { id: 7, text: 'Sent Letter', value: 'Sent Letter' },
  { id: 8, text: 'Sent Postcard', value: 'Sent Postcard' },
];
